import { render, staticRenderFns } from "./CreateReportCard.vue?vue&type=template&id=1d87d5bf&scoped=true&"
import script from "./CreateReportCard.vue?vue&type=script&lang=js&"
export * from "./CreateReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d87d5bf",
  null
  
)

export default component.exports